module.exports = __webpack_public_path__ + "static/contactBottom2-813367002eed0d694fc7afd72db485a0.jpg";